import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable, Subject} from 'rxjs';

import {handleMultiScan} from 'shared/utils';
import {ContentState} from 'shared/types';
import {ListState, StreamInput } from 'shared/interfaces';
import {ContentStatus} from 'shared/enums';
import {OrganizationModel} from 'shared/models';

@Injectable()
export class OrganizationsService {
  readonly listSubject: BehaviorSubject<StreamInput<ListState<OrganizationModel>>>;
  readonly add: Subject<OrganizationModel>;
  readonly update: Subject<{
    model: OrganizationModel;
    oldModel: OrganizationModel;
  }>;
  readonly remove: Subject<OrganizationModel>;
  readonly listState$: Observable<ContentState<ListState<OrganizationModel>>>;

  constructor() {
    this.listSubject = new BehaviorSubject<StreamInput<ListState<OrganizationModel>>>(
      {
        status: ContentStatus.INITIATED,
      }
    );
    this.add = new Subject<OrganizationModel>();
    this.update = new Subject<{
      model: OrganizationModel;
      oldModel: OrganizationModel;
    }>();
    this.remove = new Subject<OrganizationModel>();
    this.listState$ = this.listSubject.pipe(
      handleMultiScan<ListState<OrganizationModel>, OrganizationModel>({
        add: this.add,
        update: this.update,
        remove: this.remove,
      })
    );
  }
}
